/** Query keys compartilhadas — arquivo isolado para evitar import circular. */
export const KANBAN_SITUACOES_QUERY_KEY = ["kanban", "situacoes"]
export const FLUXO_MOTIVOS_QUERY_KEY = ["fluxo", "motivos"]
